import React from 'react';
import styled from 'styled-components';

export default function InfoItem({ title, subTitle }) {
  return (
    <Root className='info-block'>
      <Title>{title}</Title>
      <SubTitle>{subTitle}</SubTitle>
    </Root>
  );
}

const Root = styled.div`
  flex-direction: column;
  display: flex;
  flex: 1;
  min-width: 0;
`;

const Title = styled.div`
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: var(--td-font-gray-1);
  margin-right: 13px;
`;

const SubTitle = styled(Title)`
  font-size: 12px;
  line-height: 14px;
  color: var(--td-font-gray-2);
`;
